import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
    "providedIn": "root"
})
export class SpinnerInterceptor implements HttpInterceptor {
    private spinnerService = inject(SpinnerService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {        
        if (request.headers.has("X-SHOW-SPINNER")) {
            const spinnerMessage = request.params.get("spinnerMessage");
            let responseComplete = false;

            this.spinnerService.startHttpCall(request.params.get("spinnerMessage"));
            return next.handle(request.clone({ "headers": request.headers.delete("X-SHOW-SPINNER") })).pipe(
                tap((res) => {
                        if (res.type === HttpEventType.Response && !responseComplete) {
                            this.spinnerService.finishHttpCall(spinnerMessage);
                            responseComplete = true;
                        }
                    },
                    (err) => {
                        this.spinnerService.finishHttpCall(spinnerMessage, true);
                        responseComplete = true;
                    },
                    () => {
                        if (!responseComplete) {
                            this.spinnerService.finishHttpCall(spinnerMessage);
                            responseComplete = true;
                        }
                    })
            );
        }
        else {
            return next.handle(request.clone());
        }
    }
}

@Injectable({
    "providedIn": "root"
})
export class SpinnerService {
    private httpStackCount = 0;
    private messageStack: string[] = [];
    private messagesSubject = new Subject<string[]>();
    /** BehaviorSubject so late subscribers (e.g. <spinner /> after router-outlet children) see current visibility. */
    private spinnerSubject = new BehaviorSubject<boolean>(false);

    
    startHttpCall(spinnerMessage: string = ""): void {
        this.httpStackCount++;

        if (this.httpStackCount == 1) {
            this.spinnerSubject.next(true);
        }

        if (spinnerMessage != null && spinnerMessage != "") {
            this.messageStack.push(spinnerMessage);
            this.messagesSubject.next(this.messageStack);
        }                        
    }

    finishHttpCall(spinnerMessage: string = "", finishAll: boolean = false): void {
        if (this.httpStackCount === 0) {            
            this.spinnerSubject.next(false);
            this.messageStack = [];
            this.messagesSubject.next([]);
        } else if (finishAll) {
            this.httpStackCount = 0;
            this.spinnerSubject.next(false);
            this.messageStack = [];
            this.messagesSubject.next([]);
        } else {
            this.httpStackCount--;

            if (this.httpStackCount === 0) {
                this.spinnerSubject.next(false);
                this.messageStack = [];
                this.messagesSubject.next([]);
            } else {
                if (spinnerMessage != null && spinnerMessage != "") {
                    const index = this.messageStack.indexOf(spinnerMessage);
                    this.messageStack.splice(index, 1);
                    this.messagesSubject.next(this.messageStack);
                }
            }
        }
    }

    get updateMessages(): Observable<string[]> {
        return this.messagesSubject;
    }

    get showSpinner(): Observable<boolean> {
        return this.spinnerSubject.asObservable();
    }
}
